import { createActionGroup, props } from '@ngrx/store';
import { SecurityInfo } from './security-info.state';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const SecurityInfoResolverActions = createActionGroup({
  source: 'Security Info Resolver',
  events: {
    'Security Info requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const SecurityInfoApiActions = createActionGroup({
  source: 'Security Info API',
  events: {
    'Security Info loaded': props<{ securityInfo: SecurityInfo }>(),
    'Security Info loaded error': props<{ error: ErrorModel }>(),
  },
});
